import { ExcludeStringFromDateParams } from './types';
import * as DateFns from 'date-fns';
import * as DateFnsTz from 'date-fns-tz';

export * from './dateTimeUtils';
export * from './parseUtils';
export * from './dateOperations';
export { dissectRelativeDate } from './dissectRelativeDate';
export { relativeDateDisplayLabel } from './relativeDateDisplayLabel';
export { TimeFrameUnit } from './TimeFrameUnit';
export type { DissectedRelativeDate } from './types';
export { relativeDateLabelFormatters } from './relativeDateLabelFormatters';
export {
  getTodayOption,
  getTomorrowOption,
  getYesterdayOption,
  TODAY_VALUE,
  TOMORROW_VALUE,
  YESTERDAY_VALUE,
} from './consts';
export { getRelativeDateRange } from './getRelativeDateRange';

export const {
  compareDesc,
  formatDistanceToNow,
  eachDayOfInterval,
  formatRelative,
  setSeconds,
  setMilliseconds,
  startOfToday,
  subDays,
  differenceInDays,
  differenceInSeconds,
  isToday,
  addHours,
  startOfHour,
  addDays,
  format,
  formatDuration,
  intervalToDuration,
  endOfDay,
  add,
  addQuarters,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  subMilliseconds,
  sub,
  endOfISOWeek,
  getISOWeek,
  getQuarter,
  getYear,
  startOfISOWeek,
  subQuarters,
  isBefore,
  isAfter,
  max,
  min,
  differenceInMinutes,
  isSameDay,
  isYesterday,
  /**
   * We remove string parsing from date-fns functions in order to enforce usage
   * of our own parse functions to handle date vs dateTime correctly, which is
   * easy to mistake when date-fns is so flexible.
   */
} = DateFns as ExcludeStringFromDateParams<typeof DateFns>;

export type { FormatDistanceToNowOptions } from 'date-fns';

export const { getTimezoneOffset, formatInTimeZone, toZonedTime } =
  DateFnsTz as ExcludeStringFromDateParams<typeof DateFnsTz>;
